export default "__VITE_ASSET__D0pT64UE__"